import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" List Hound on Marketplace ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("LIST ON MARKETPLACE")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_input_number = _resolveComponent("n-input-number")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_n_form = _resolveComponent("n-form")!

  return (_openBlock(), _createBlock(_component_n_form, {
    model: _ctx.formValue,
    ref: "formRef",
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.listHound()), ["prevent"])),
    rules: _ctx.rules
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_card, {
        segmented: {
        footer: 'soft',
        content: true
      },
        closable: "",
        onClose: _ctx.cancel
      }, {
        header: _withCtx(() => [
          _hoisted_1
        ]),
        action: _withCtx(() => [
          _createVNode(_component_n_space, { justify: "right" }, {
            default: _withCtx(() => [
              _createVNode(_component_n_button, {
                disabled: _ctx.loading,
                type: "primary",
                "attr-type": "submit",
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["disabled", "loading"])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_n_form_item, {
            label: "Hound",
            path: "houndId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_select, {
                disabled: _ctx.loading,
                class: "big-select",
                options: _ctx.houndOptions,
                value: _ctx.formValue.houndId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formValue.houndId) = $event)),
                style: {"width":"100%"},
                "render-label": _ctx.renderLabel,
                "render-tag": _ctx.renderTag
              }, null, 8, ["disabled", "options", "value", "render-label", "render-tag"])
            ]),
            _: 1
          }),
          _createVNode(_component_n_form_item, {
            label: "Breeding Fee",
            path: "breedingFee"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_input_number, {
                disabled: _ctx.loading,
                value: _ctx.formValue.breedingFee,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formValue.breedingFee) = $event)),
                style: {"width":"100%"}
              }, {
                suffix: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.currencyName), 1)
                ]),
                _: 1
              }, 8, ["disabled", "value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClose"])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}